import { BDSProvider, Box, Container, CustomStepper, Divider } from '@barracuda-internal/bds-core-v2';
import React, { ReactElement } from 'react';
import FEATURES from 'src/featureMap';
import withAnalytics from 'src/lib/withAnalytics';
import ServicesSetup from 'src/routes/onboarding/ServicesSetup';
import { OnboardingStepProps } from 'src/routes/onboarding/types';
import Welcome from 'src/routes/onboarding/Welcome';
import RequestPIConsent from 'src/routes/onboarding/RequestPIConsent';
import DataSetup from './onboarding/DataSetup';

type StepsType = {
	label: string;
	component: (props: OnboardingStepProps) => ReactElement;
	width: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

const STEPS: StepsType[] = [
	{
		label: 'Welcome',
		component: Welcome,
		width: 'sm',
	},
	{
		label: 'Personal Information Consent',
		component: RequestPIConsent,
		width: 'sm',
	},
	{
		label: 'Configuration',
		component: DataSetup,
		width: 'sm',
	},
	{
		label: 'Connect Services',
		component: ServicesSetup,
		width: 'lg',
	},
];

function OnboardingPage(): ReactElement {
	const isSetup = localStorage.getItem('is_setup') == 'true';
	const [activeStep, _setActiveStep] = React.useState(isSetup ? 3 : 0);

	const setActiveStep = withAnalytics(
		FEATURES.onboardingPageChange,
		(step) => {
			_setActiveStep(step);
		},
	);

	const stepperSteps = STEPS.map((page, index) => ({
		step: index,
		label: page.label,
	}));

	const PageComponent = STEPS[activeStep].component;
	return (
		<BDSProvider>
			<Box sx={{ padding: '24px' }}>
				<Box sx={{ width: '100%', maxWidth: '720px', margin: 'auto', marginTop: '24px' }}>
					<CustomStepper
						steps={stepperSteps}
						activeStep={activeStep}
						variant="horizontal"
					/>
				</Box>
				<Divider sx={{ marginTop: '24px' }} />

				<Container maxWidth={STEPS[activeStep].width}>
					<PageComponent
						setStep={setActiveStep}
						activeStep={activeStep}
					/>
				</Container>
			</Box>
		</BDSProvider>
	);
}

export default OnboardingPage;
